fx.ns("desktop.common.board", class Board extends fx.components.Scrollable
{
    constructor(model, componentFactory, options)
    {
        super(model.creation, "vertical");

        this._model = model;
        this.options = options;
        this._views = [];

        this._editableAreas = [];

        this._componentFactory = componentFactory;
        this.model.history.mode = "editor";
        
        this._currentArea;
        this._currentElement;

        this.listenUpdates( this.model.photos, true);
        this.listenUpdates( this.model.layouts, true);
        this.listenUpdates( this.model.backgrounds, true);
        this.listenUpdates( this.model.customcolors, true);
    }

    // ---------- Getter / setter

    get model()
    {
        return this._model;
    }

    get creation()
    {
        return this.data;
    }

    get views()
    {
        return this._views;
    }

    get componentFactory()
    {
        return this._componentFactory;
    }

    get currentArea()
    {
        return this._currentArea;
    }

    get currentArea()
    {
        return this._currentArea;
    }

    set currentArea(val)
    {
        if (this._currentArea == val || !val)
            return;

        if (this._currentArea)
            this._currentArea.active = false;
        
        this._currentArea = val;

        if (this._currentArea)
            this._currentArea.active = true;

        this.currentElement = null;

        this.guidelines.currentArea = this._currentArea;

        if (this.model.history)
            this.model.history.currentPage =  this._currentArea.data;

        if (this._currentArea)
            this.trigger("currentAreaChanged", this._currentArea);
    }

    get currentElement()
    {
        return this._currentElement;
    }

    set currentElement(val)
    {
        if (this._currentElement == val)
        {
            if (this._currentElement)
                this._currentElement.activate(true);
        }
        else
        {
            if (this._currentElement)
            {
                this.listenUpdates( this._currentElement.data, false );
                this._currentElement.activate( false );
            }
        
            this._currentElement = val;

            this.frameAction.currentArea = this.currentArea;
            this.frameAction.currentElement = val;
            this.toolBar.currentElement = this._currentElement;

            this.frame.hide();

            if (this._currentElement)
            {
                this._currentElement.activate( true );
                
                this.frame.currentArea = null;
                this.frame.currentElement = null;

                this.listenUpdates( this._currentElement.data, true );
            }
        }
        
        this.trigger("currentElementChanged", this._currentElement);  
    }

    get currentPage()
    {
        return this._currentPage;
    }

    set currentPage(val)
    {
        this._currentPage = val;
        this._scrollToCurrentPage();
    }

    get currentView()
    {
        if (this._previousZoom != this.model.zoom.value)
        {
            let view;
            for (let i = 0; i < this.views.length; i++)
            {	
                if ( (this.views[i].zoom.length == 1 && this.views[i].zoom[0] == this.model.zoom.value) ||
                        (this.views[i].zoom[0] <= this.model.zoom.value && this.views[i].zoom[1] >= this.model.zoom.value) )
                {
                    view = this.views[i].view;
                    break;
                }
                
            }
        
            this._currentView = view;
            this._previousZoom = this.model.zoom.value;
        }

        return this._currentView;
    }

    // To override
    buildBoard()
    {
    }

    addEditableArea(area, viewport, position)
    {
        area.autoDelete = false;
        area.options = this.options;

        position = (position !== undefined) ? position : undefined;

        this.addChild(area, viewport, "", position);

        this._editableAreas.push(area);
    }

    removeEditableArea(area)
    {
        if (area)
        {
            this.removeChild(area, true);
            this._editableAreas.remove(area.id);
        }
    }

    removeAllEditableAreas()
    {
        let area;
        while(area = this._editableAreas.pop())
        {
            this.off("select", this.onSelect, area);
            this.removeChild(area, true);
        }
    }

    getArea(id)
    {
        for (let i = 0; i < this._editableAreas.length; i++)
        {
            if (this._editableAreas[i].id == id)
                return this._editableAreas[i];
        }
    }

    getAreaForPage(id)
    {
        for (let i = 0; i < this._editableAreas.length; i++)
        {
            if (this._editableAreas[i].data && this._editableAreas[i].data.id == id)
                return this._editableAreas[i];
        }
    }

    enable()
    {    
        if (this.enabled)
            return;
                
        super.enable();

        this._mouse.enable();    

        this.on("scrollChanged", this.onScroll);                
    }

      
    disable()
    {
        if (!this.enabled)
            return;
                
        super.disable();

        this._mouse.disable();

        this.off("scrollChanged", this.onScroll);
    }


    show(callback){
		
        super.show(callback);
        
        this.toolBar.hide();
        this.frame.hide();
        this.frameAction.hide();
	}


    destroy()
    {
        super.destroy();

        this.guidelines.destroy();
        this.frame.destroy();
        this.frameAction.destroy();
        this.toolBar.destroy();

        this._mouse.disable();
        this._mover.disable();
        this._resizer.disable();
        this._innerDragger.disable();
    }


    scrollToCurrentArea(animate)
    {   
        if (this.currentArea)
        {
            let position = this.currentView.getPosition(this.currentArea);
            
            if (!position) return;

            let yPos = position.y * position.scale - (this.realHeight - this.currentArea.realHeight * this.currentArea.scale) / 2;
            this.scroll( yPos, animate );
        }
    }


    // ------------ Overrides 

    contextMenu(e)
	{
        let menu = [];
        
        if (this._clipBoard)
            menu.push({label : "Coller", code : "paste"})
        
        if (e && this.currentElement && fx.dom.parent(e.target, this.currentElement.node) && this.currentElement.selectable)
        {
            if (this.currentElement.removable)
            {
                if (menu.length > 0)
                    menu.push({});

                if (fx.get("app") != "print") 
                {
                    menu.push({label : fx.text("Copier"), code : "copy"});
                    menu.push({label : fx.text("Couper"), code : "cut"});
                    menu.push({label : fx.text("Supprimer"), code : "delete"});
                }       
            }
        }

        return menu;
    }

    onContextMenu(e)
	{
        switch(e.detail.code)
		{
			case "paste":
				this._onPaste(null, e.detail.x, e.detail.y);
                break;

            case "copy":
                this._onCopy(e);
                break;
                
            case "cut":
                this._onCut(e);
                break;
			
			case "delete" :
                if (this.currentElement && this.currentElement.removable)
				    this.currentElement.data.delete();
				break;

        }
    }


    create()
    {
        super.create();

        this.frame = new shared.stage.Frame(this.model);
        this.frameAction = new shared.stage.FrameAction(this.model);
        this.toolBar = new desktop.common.toolbar.ToolBar(this.frameAction, this.model);

        this._mouse = new desktop.common.behaviour.Mouse(this, this.model.creation);
        this.guidelines = new shared.stage.GuideLines( this._mouse, this.model );

        this._mover = new desktop.common.behaviour.Move(this._mouse, this.guidelines, this.model);
        this._resizer = new desktop.common.behaviour.Resize(this._mouse, this.guidelines, this.model);
        this._innerDragger = new desktop.common.behaviour.InnerDragger(this._mouse, this.model);

        this.addChild(this.frame);
        this.addChild(this.frameAction);
        this.addChild(this.toolBar);
        this.addChild(this.guidelines);
    }

    onReady()
    {
        super.onReady();

        this.on("select", this.onSelect, this._mouse);
        this.on("over", this.onOver, this._mouse);
        this.on("out", this.onOut, this._mouse);
        this.on("move", this.onMove, this._mouse);
        this.on("resize", this.onResize, this._mouse);
        this.on("click", this.onClick, this);

        this.on("LEFT-DOWN", this._onLeft, fx.keyboard);
        this.on("RIGHT-DOWN", this._onRight, fx.keyboard);
        this.on("UP-DOWN", this._onUp, fx.keyboard);
        this.on("DOWN-DOWN", this._onDown, fx.keyboard);

        this.on("CTRL+LEFT-DOWN", this._onCtrlLeft, fx.keyboard);
        this.on("CTRL+RIGHT-DOWN", this._onCtrlRight, fx.keyboard);
        this.on("CTRL+UP-DOWN", this._onCtrlUp, fx.keyboard);
        this.on("CTRL+DOWN-DOWN", this._onCtrlDown, fx.keyboard);

        this.on("CTRL+C-DOWN", this._onCopy, fx.keyboard);
        this.on("CTRL+X-DOWN", this._onCut, fx.keyboard);
        this.on("CTRL+V-DOWN", this._onPaste, fx.keyboard);
        
        this.on("DELETE-DOWN", this._onDelete, fx.keyboard);

        this.on("ESCAPE-DOWN", this._onEscape, fx.keyboard);

        this.on("CTRL+S-DOWN", this._onSave, fx.keyboard);

        this.on("CTRL+Z", this._onUndo, fx.keyboard);
        this.on("CTRL+Y", this._onRedo, fx.keyboard);

        this.on("currentPage-updated", this._currentPageUpdated, this.model.history);
        
        //this.on("photo-extracted", this._onPhotoExtracted, fx.service("MediasUploader"));
        //this.on("photo-extracted", this._onPhotoExtracted, fx.service("GoogleService"));

        if (!this.guidelines.creation)
            this.guidelines.creation = this.creation;
    }


    removeFrame()
    {
        if (this.frame)
        {
            this.frame.hide();
            this.frame.currentElement = null;
        }
    }
    // ------------ Events

     // when history back/forward and current page changes
     _currentPageUpdated()
     {
         this.currentPage = this.model.history.currentPage;
     }

    _onLeft(e)
    {
        if (this.currentElement)
        {
            if (this._moveElement(this.currentElement.data.x - 1, this.currentElement.data.y, e))
                e.cancel();
        }
    }

    _onCtrlLeft(e)
    {
        if (this.currentElement)
        {
            if (this._moveElement(this.currentElement.data.x - 10, this.currentElement.data.y, e))
                e.cancel();
        }
    }
    
    _onRight(e)
    {
        if (this.currentElement)
        {
            if (this._moveElement(this.currentElement.data.x + 1, this.currentElement.data.y, e))
                e.cancel();
        }
    }

    _onCtrlRight(e)
    {
        if (this.currentElement)
        {
            if (this._moveElement(this.currentElement.data.x + 10, this.currentElement.data.y, e))
                e.cancel();
        }
    }
    
    _onUp(e)
    {
        if (this.currentElement)
        {
            if (this._moveElement(this.currentElement.data.x, this.currentElement.data.y - 1, e))
                e.cancel();
        }
    }

    _onCtrlUp(e)
    {
        if (this.currentElement)
        {
            if (this._moveElement(this.currentElement.data.x, this.currentElement.data.y - 10, e))
                e.cancel();
        }
    }

    _onDown(e)
    {
        if (this.currentElement)
        {
            if (this._moveElement(this.currentElement.data.x, this.currentElement.data.y + 1, e))
                e.cancel();
        }
    }

    _onCtrlDown(e)
    {
        if (this.currentElement)
        {
            if (this._moveElement(this.currentElement.data.x, this.currentElement.data.y + 10, e))
                e.cancel();
        }
    }

    _onCopy(e)
    {
        if (this.currentElement && this.currentElement.removable)
        {
            this._clipBoard = this.currentElement ? this.currentElement.data.duplicate() : null;
            if (this.currentElement)
            {
                if (!(this.currentElement.active && this.currentElement instanceof shared.stage.components.Text))
                {
                    if (e.cancel) // in case of keyboard event
                        e.cancel();
                }
            }
        }
    }

    _onCut(e)
    {
        if (this.currentElement && this.currentElement.removable)
        {
            this._clipBoard = this.currentElement ? this.currentElement.data.duplicate() : null;

            if (this.currentElement)
            {
                if (this.currentElement instanceof shared.stage.components.Photo && fx.get("app") == "print") 
                    return;

                if (!(this.currentElement.active && this.currentElement instanceof shared.stage.components.Text))
                {
                    if (e.cancel) // in case of keyboard event
                        e.cancel();
                }

                this.currentElement.data.delete();
            }
        }
            
    }
        
    _onPaste(e, x, y)
    {
        if (this.currentElement && this.currentElement.removable && this.currentElement.active && this.currentElement instanceof shared.stage.components.Text)
            return;

        if (this._clipBoard && this.currentArea)
        {
            if (this._clipBoard.isPhoto && Utils.isID(this._clipBoard.content) && Utils.temporaryId(this._clipBoard.content))
                this._clipBoard.content = Utils.temporaryId(this._clipBoard.content);
                
            let data = this._clipBoard.JSON();
            if (e == null) // Mouse Event
            {
                // let's set _clipBoard component to x, y position
                let pos = fx.graphics.globalToLocal( this.currentArea.stage.node, x , y );
                data.x = pos.x / this.currentArea.scale - (data.width / 2);
                data.y = pos.y / this.currentArea.scale - (data.height / 2);
            }
            else
            {
                data.x += 5;
                data.y += 5;
            }

            this.currentArea.addComponent( data );
            this.currentElement = null;

            if (e && e.cancel)// in case of keyboard event
                e.cancel();
        }

    }

    _onDelete(e)
    {
        if (this.currentElement && this.currentElement.data && this.currentElement.selectable && this.currentElement.removable)
        {
            // don't allow to delete pictures manually on print editor
            if (this.currentElement instanceof shared.stage.components.Photo && fx.get("app") == "print") 
                return;

            this.currentElement.data.delete();
            if (e.cancel)// in case of keyboard event
                e.cancel();
        }
    }

    _onEscape(e)
    {
        if (this.currentElement)
        {
            if (this.currentElement.active && this.currentElement instanceof shared.stage.components.Text)
                this.currentElement.activate(false);
            else
                this.currentElement = null;        

            e.stopPropagation();
        }
            
    }

    _onSave(e)
    {
        e.preventDefault();
        e.stopPropagation();
    }

    _onUndo(e)
    {
        this.model.history.undo();
    }

    _onRedo(e)
    {
        this.model.history.redo();
    }

    _moveElement(x, y, e)
    {
        if (this.currentElement && this.currentElement.editable)
        {
            this.currentElement.move(x, y);
            e.stopPropagation();
            return true;
        }
        else
            return false;
    }
    
    onSelect(event)
    {
        let area = event.detail ? event.detail.area : event.area;
        let element = event.detail ? event.detail.element : event.element;

        this.currentArea = area;
        this.currentElement = element;

        this._mouse.selectedElement = element;
        this._mouse.selectedArea = area;

        /*if (this.currentElement && this.currentElement.data.isPhoto && this.currentElement.empty)
        {
            // let show photo galery
            fx.set("photo-selected", this.currentElement);

            this.data.event("selectphotos");
        }*/
    }

    /*_onPhotoExtracted(event)
    {
        let photoComponent = fx.get("photo-selected");

        if (photoComponent && photoComponent.data)
        {
            photoComponent.data.content = event.detail.id;
            fx.set("photo-selected", null);
        }
    }*/

    onOver(event)
    {
        this.frame.currentArea = event.area; 

        if (event.element != this.currentElement)
            this.frame.currentElement = event.element;
    }

    onOut(event)
    {
        this.frame.currentArea = null;
        this.frame.currentElement = null;
    }

    onMove(event)
    {
        if (event.state == "action")
            this.currentElement = null; 
    }

    onResize(event)
    {
        if (event.state == "action")
            this.toolBar.currentElement = null;
        else
        if (event.state == "end")
            this.toolBar.currentElement = this.currentElement;

    }

    onClick(event)
    {
        let addRemoveElement = fx.dom.parent(event.target, ".AddPageComponent");

        if(addRemoveElement && fx.dom.parent(event.target, ".add-page"))
        {
            let elt = this.scrollableContent.getChild(addRemoveElement.id);
            if (!elt)
                return;

            let page = elt.data;

            if (this.book.canAdd)
            {
                if (!this.model.account.wasNotificated("multiple-four"))
                    this.delay(this._showAddPagePopup, 1000);
                
                this.book.addPage(page, "right", false, true, this.model.layouts);
            }
                
            else
                this.popup(new shared.popups.RemoveAddImpossiblePopup(this.book, "adding"));

		}
    }

     _showAddPagePopup()
    {
        this.popup(new common.popups.AddPagePopup(), { closeCurrent : true});
        this.model.account.notificated("multiple-four")
    }

    updateDisplay(onlyIfAsked)
    {
        this.delay(this.updateCurrentView, 250);
        
        super.updateDisplay(onlyIfAsked);
    }

    onDisplayUpdated()
    {
        // if screen is resized, we just unselect current element, so toolbar is removed and frame also.
        this.currentElement = null;
    }

   
    onDataEvent(event)
    {
        switch(event.type)
        {
            case "apply-layout-all" :
                let layout = this.model.layouts.find({id : event.detail.content});
                this.currentArea.applyLayoutAll( layout );
                event.cancel(); // so layout is not applied somewhere else
                break;

            case "apply-background" :
                if (event.detail && event.detail.area)
                    this.currentArea = this.getAreaForPage(event.detail.area);

                this.currentArea.applyBackground( {content : event.detail.content, component_type: "background"} );
                event.cancel(); 
                break;

            case "apply-background-all" :
                this.creation.applyBackgroundAll({content : event.detail.content, component_type: "background"});
                event.cancel(); 
                break;
            
            case "update-background-color-all" :
                this.creation.applyBackgroundColorAll( event.detail );
                event.cancel();
                break;

            case "update-background-color" :
                this.currentArea.setBackground( event.detail );
                break;

            case  "numbering-changed" :
                this.delay(this.updateCurrentView, this._newPage ? 0 : 250); 
                break;

            case "drag-over":
                for(let i = 0; i < this._editableAreas.length; i++)
                {
                    let area = this._editableAreas.getItemAt(i);
                    if (area.stage)
                    {
                        let components = area.stage.getChilds();
                        for(let j = 0; j < components.length; j++)
                        {
                            let component = components.getItemAt(j);
                            if (component.data.id == event.model.id)
                            {
                                this.frame.currentArea = area; 
                                this.frame.currentElement = component;
                            }
                        }
                    }
                }
                break;

            case "drag-out":
                this.onOut();
            break;

            default : 
                super.onDataEvent(event);
                break;
        }
                
    }

    onDataUpdated(action)
    {
        super.onDataUpdated(action);

        if (action.type == "init")
        {
            if (action.model instanceof models.Creation && action.model.elements)
            {
                this.listenUpdates( this.data.elements, true );
                this.buildBoard();
                //this.currentArea = this.cover;
            }
            return;
        }
        
         // Component is deleted on stage, let's un-select it (hide Toolbar, remove Frame)
         if (action.type == "delete" && action.model instanceof models.CreationElementContent)
        {
            if (this.currentElement && (this.currentElement.data == null || action.model == this.currentElement.data) )
                this.currentElement = null;
            
            return;
        }

        if (action.type == "update" && action.model instanceof models.CreationElementContent && action.history)
            this.currentElement = null;
        

       
        if (this.currentElement)
        {
            // case when a text is updated, let's check if it's size was updated
            if (action.type == "update" && 
                action.model instanceof models.CreationElementContent && 
                action.impacts("height") && 
                action.model.isText && 
                action.model == this.currentElement.data)
            {
                this.guidelines.checkElement( this.currentElement );
            }
        }
    }


    onScroll()
    {
        this.trigger("scrolled");

        if (this.currentView && (typeof this.currentView.scroll == "function"))
        {
            let activeArea = this.currentView.scroll(true);

            if (!this._scrollUpdateEnabled) return;
            
            if (this.model.zoom.value <= 100)
                this.currentArea = activeArea;
        }
    }
    
    updateCurrentView(noanimate)
    {
        this.currentView.update(!noanimate);
    }

    disableScrollUpdates()
    {    
        this._scrollUpdateEnabled = false;
        this.delay(this.allowScrollUpdates, 500);
    }

    allowScrollUpdates()
    {
        this._scrollUpdateEnabled = true;
    }


});
     